/**
 *
 * お店の検索用Tags
 *
 */
import { firestore } from 'firebase';
import DatabaseAdapter from 'src/firebase/db/DatabaseAdapter';
import ValidationManager, { ValidationResponse } from 'src/firebase/db/ValidationManager';
import { InternalError } from 'src/firebase/db/ApplicationError';

export const messageInitialEntity = {
  title: '',
  body: '',
  has_sound: true,
  zendesk_url: '',
  send_time: new Date(),
  publish_status: '0',
  created_at: {} as firestore.FieldValue,
  updated_at: {} as firestore.FieldValue,
};
export type MessageEntity = typeof messageInitialEntity;
export const messageEntityKeys = (Object.keys(
  messageInitialEntity,
) as unknown) as (keyof MessageEntity)[];

class MessagesDB extends DatabaseAdapter {
  constructor(props: any) {
    super(props);
    this.setSchemaKeys(messageEntityKeys);
  }

  async getPushNotifications() {
    const docRef = this.getConnection();
    const snapshot = await docRef.get();
    const notifications = snapshot.docs.map((doc) => {
      return doc.data();
    });
    return notifications;
  }

  create(query: Partial<MessageEntity>) {
    const filteredQuery = this.filterQuery(query);
    const validationErrors = this.getValidationErrors(filteredQuery);
    if (validationErrors) return validationErrors;
    const requestQuery = {
      ...filteredQuery,
      created_at: this.getServerTimeStamp(),
      updated_at: this.getServerTimeStamp(),
    };

    const ref = this.getConnection();
    return ref
      .add(requestQuery)
      .then(async (snapshot) => {
        const id = snapshot.id;
        const doc = await this.getDocumentRef(id);
        return this.formatSuccess(doc);
      })
      .catch((err) => {
        console.log(err);
        throw new InternalError(err.message ? err.message : 'System Error');
      });
  }

  getValidationErrors(query: Partial<MessageEntity>): ValidationResponse | null {
    const validator = new MessagesValidationManager();

    messageEntityKeys.forEach((key) => {
      switch (key) {
        case 'title':
        case 'body':
          validator.isRequired(key, query[key]);
          break;
        case 'send_time':
          validator.isRequired(key, query[key]);
          validator.isValidSendTime(query[key]);
          break;
        case 'has_sound':
          validator.isBoolean(key, query[key]);
          break;
      }
    });

    return validator.isPass() ? null : validator.throwValidateError(validator.getErrors());
  }
}

class MessagesValidationManager extends ValidationManager {
  isValidSendTime(date: Date | undefined) {
    const isBefore = this.isNowBefore(date);
    console.log(date, isBefore);
    if (!isBefore) {
      this.addErrors('send_time', `送信時刻が過去の時刻になっています`);
    }
  }
}

export default new MessagesDB({
  schema: 'messages',
});
